module.exports = "/images/14K-2T.webp?a05d3c70d73709545843a869b4e1a6e5";